/**
 * A global namespace for `offsetWidth` property.
 */
const offsetWidth = 'offsetWidth';
export default offsetWidth;
